import { createSelector } from 'reselect';

export const getAssets = state => state.asset && state.asset.assets;
export const getLoadingAsset = state => state.asset && state.asset.loading;
export const getSelectedAssetId = state => state.asset && state.asset.selectedAssetId;
export const getSearchString = state => state.asset && state.asset.searchString;

export const getAllAssets = createSelector(
  getAssets,
  assets => assets && assets.ids.map(id => assets.entities[id])
);

export const getSelectedAsset = createSelector(
  [getAssets, getSelectedAssetId],
  (assets, selectedAssetId) => assets && assets.entities[selectedAssetId]
);



// WEBPACK FOOTER //
// ./src/selectors/asset.js